/**
 * Common error state component
 */

import { AlertCircle, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { getErrorMessage, type ErrorContext } from '@/utils/errorHandler';

interface ErrorStateProps {
  error: unknown;
  context?: ErrorContext;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({
  error,
  context,
  onRetry,
  retryLabel = 'Try Again',
}: ErrorStateProps) {
  const message = getErrorMessage(error, context);

  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center p-12">
        <div className="rounded-full bg-destructive/10 p-4 mb-4">
          <AlertCircle className="h-8 w-8 text-destructive" />
        </div>
        <CardHeader className="text-center">
          <CardTitle>Error loading data</CardTitle>
          <CardDescription>{message}</CardDescription>
        </CardHeader>
        {onRetry && (
          <Button onClick={onRetry} variant="outline" className="mt-4">
            <RefreshCw className="h-4 w-4 mr-2" />
            {retryLabel}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}






